"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlickgridConfig = void 0;
const global_grid_options_1 = require("./global-grid-options");
class SlickgridConfig {
    constructor() {
        this.options = global_grid_options_1.GlobalGridOptions;
    }
}
exports.SlickgridConfig = SlickgridConfig;
//# sourceMappingURL=slickgrid-config.js.map